import { connect } from 'react-redux'
import ModalActions from '../../../../../Redux/ModalRedux'
import PrintersOutOfPaper from './printers-out-of-paper-modal'
import PrintersOutOfPaperSelector from './printers-out-of-paper-modal.selector'
import { pipe } from 'ramda'
import { translate } from 'react-translate'

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(ModalActions.modalClose())
  }
}

export default pipe(
  translate('CardsModals'),
  connect(
    PrintersOutOfPaperSelector,
    mapDispatchToProps
  )
)(PrintersOutOfPaper)
